/* IMS Actions */
import { SUBMIT_FORM, THROW_ERROR } from '../constants';
import api from '../api/apcApi';

export const submitForm = (values, history) => async (dispatch, getState) => {
  const contactObject = {
    programType: 'APC',
    accountId: getState().company.selectedCompany.recId,
    authKey: getState().company.selectedCompany.authKey,
    language: getState().i18n.locale,
    phone: values.phone.trim(),
    jobRole: values.jobRole,
  };

  dispatch({ type: SUBMIT_FORM, payload: contactObject });
  // make axios post request and catch errors if any
  try {
    const response = await api.post('/v1/register?programType=APC', contactObject,
      {
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken().token}`,
          'x-api-key': window.apcConfig.adobeIO.apiKey,
          // Prefer: 'example=approved',
        },
      });
    if (response.data.pendingApproval) {
      // Send to the pending approval thank you page
      history.push('/thank_you_public');
    } else {
      // Send to the regular thank you page.
      history.push('/thank_you');
    }
  } catch (error) {
    dispatch({
      type: THROW_ERROR,
      payload: { messagePath: 'workflow.error_page.submit_request_problem' },
    });
    window.console.error('Error: Problem submitting form, API call failed.', error);
    if (window.newrelic) {
      window.newrelic.noticeError(error.message,
        {
          page: 'Personal Information',
          api: '/v1/register',
          fatal: false,
          user: window.adobeIMS.getUserProfile().email,
        });
    }
    // throw new SubmissionError({ Exception: error });
  }
};

export default submitForm;
